import { observable, action } from 'mobx';
import { Advert, SiteAdverts, Category } from '../models';
import { AdvertSlot } from '../constants/advertSlot';
import {
  default as getRepository,
  AdvertRepository
} from '../repositories/Advert';

export class AdvertStore {
  public repository: AdvertRepository = getRepository();

  @observable public adverts: SiteAdverts = new SiteAdverts();
  @observable public activeAdverts: { [slotName: string]: Array<Advert> };

  @action
  fetchAdvertsForSlot = async (slotName: AdvertSlot): Promise<void> => {
    if (!this.activeAdverts) {
      this.activeAdverts = await this.repository.fetchAll();
    }

    const adverts: Array<Advert> = this.activeAdverts[slotName];
    this.setAdvertsForSlot(slotName, adverts);
  };

  @action
  fetchAdvertsForCategorySlot = async (
    slotName: AdvertSlot,
    videoCategory: Category | undefined
  ): Promise<void> => {
    const adverts = await this.repository.fetchForVideoCategory(videoCategory);
    this.setAdvertsForSlot(slotName, adverts[slotName]);
  };

  @action
  setAdvertsForSlot = (slotName: AdvertSlot, adverts: Array<Advert>) => {
    this.adverts[slotName] = adverts;
  };
}

export default AdvertStore;



// WEBPACK FOOTER //
// ./src/app/stores/AdvertStore.ts